import OpenAIClient from "@/openai/OpenAIClient.js";

export default {
  AssessMe() {
    this.$emit("ModeChanged", "Assessment");
  },
  CloseAssessment() {
    this.$emit("ModeChanged", "");
  },
  OnModeChanged(mode){
    this.$emit("ModeChanged", mode);
  },
  GenerateQuestions(arrTopicsToGenerateQuestionsFor) {
      var instance = this;

      instance.$vs.loading({
        container: instance.$refs.content,
        scale: 1,
      });

      if (arrTopicsToGenerateQuestionsFor == null)
        arrTopicsToGenerateQuestionsFor = this.ContextMenuItem.children;

      var questions = arrTopicsToGenerateQuestionsFor.map((itm) => ({
        title: itm.data.Title,
        description: itm.data.Description,
        id: itm.data.Id,
      }));

      var responseFormat = [
        {
          t: "Question title", // Question text.
          tid: "", // The original article id
          a: [
            // Answers
            {
              t: "Answer 1 text", // Answer text
              c: true, // true if this is the correct answer, false itherwise.
            },
            // 2 more answers.
          ],
        },
      ];

      instance.$set(instance, "GeneratingQuestionsCount", questions.length);

      var prompt =
        "I am providing a JSON template and a few articles. USE THE SAME LANGUAGE AS THE ARTICLE! I need to get back 1-2 questions per article in the provided JSON format. NOTHING ADDITIONAL, just as if you are a JSON SERVER. Avoid asking questions that involved memorizing long strings, numbers, DNA sequences, and anything of this sort. RANDOMIZE THE CORRECT ANSWER POSITION. Here is your JSON Template:" +
        JSON.stringify(responseFormat) +
        "\n\n Ensure you provide only valid JSON AS A RESPONSE NO ADDITIONAL TEXT! BE AS BRIEF AS POSSIBLE!  DO NOT RETURN COMMENTS IN THE JSON. I need 3 possible answers, ONLY 1 answer can be correct. MAKE SURE TO RANDOMIZE QUESTIONS AND THE CORRECT ANSWER POSITION. TRY TO MAKE ANSWERS ABOUT THE SAME LENGTH. Here are the articles:" +
        JSON.stringify(questions);

      var itemToPromptFor = "DataModel.TCVelik.Embed.TCEmbed_" + this.ContextMenuItem.data.Id + "_tour";

      OpenAIClient.promptRaw(prompt, itemToPromptFor, true).then(function (response) {
        var aiResponse = response.data;
        try {
          var JSONWrapperObj = JSON.parse(aiResponse);
          var descriptionFinal = JSONWrapperObj.choices[0].message.content;
          instance.$set(instance, "CurrentTourContent", descriptionFinal);

          try {
            var result = JSON.parse(descriptionFinal);

            result = result.map(function (question) {
              question.hidden = false;
              var answers = question.a.map(function (answer) {
                answer.hidden = false;
                return answer;
              });
              question.a = answers;
              return question;
            });

            instance.$set(instance, "CurrentTourQuestionsJSON", result);
            instance.$vs.loading.close(instance.$refs.content);
          } catch (err) {
            instance.$vs.loading.close(instance.$refs.content);
            alert("Error loading your questions:" + err);
            console.error(err);
          }
        } catch (err2) {
          instance.$vs.loading.close(instance.$refs.content);
          console.error(err2);
          // No questions :)
        }
      });
  },
  RegenerateAssessment(){
    alert('Comming soon');
  }
}
